import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';
import { ApiMeta } from '../../../_core/_model/api-response';

@Component({
  selector: 'app-pagination',
  standalone: false,
  templateUrl: './pagination.html',
  styleUrl: './pagination.css',
})
export class Pagination implements OnInit, OnChanges {
  @Input() url!: string;
  @Input() counts!: ApiMeta | null;

  @Output() refresh = new EventEmitter<number>();

  queryParams!: Params;

  first = 1;
  last = 1;
  prev = 1;
  next = 1;

  range: number[] = [];
  link = '';

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.setLink();
    this.getRouteParams();
    this.drawPage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url']) this.setLink();
    if (changes['counts']) this.drawPage();
  }

  private setLink() {
    if (!this.url) return;
    const split = this.url.split('?');
    this.link = '/' + split[0].replace(/^\//, '');
  }

  get startRow(): number {
    if (!this.counts || this.counts.totalRows === 0) return 0;
    return (this.counts.currentPage - 1) * this.counts.maxRowsPerPage + 1;
  }

  get endRow(): number {
    if (!this.counts || this.counts.totalRows === 0) return 0;
    return this.startRow + this.counts.rowsOnCurrentPage - 1;
  }

  drawPage() {
    this.range = [];

    const c = this.counts;
    if (!c || c.totalPages <= 0) return;

    // window size
    const windowSize = 5;

    if (c.totalPages <= windowSize) {
      this.first = 1;
      this.last = c.totalPages;
    } else if (c.currentPage <= 3) {
      this.first = 1;
      this.last = windowSize;
    } else if (c.currentPage >= c.totalPages - 2) {
      this.first = c.totalPages - (windowSize - 1);
      this.last = c.totalPages;
    } else {
      this.first = c.currentPage - 2;
      this.last = c.currentPage + 2;
    }

    this.prev = Math.max(1, c.currentPage - 1);
    this.next = Math.min(c.totalPages, c.currentPage + 1);

    for (let i = this.first; i <= this.last; i++) this.range.push(i);
  }

  buildQueryParams(page: number) {
    return {
      ...this.queryParams,
      page
    };
  }

  route(page: number) {
    this.refresh.emit(page);
  }

  getRouteParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
}